export const PORTAL_PATH = "/";
export const GUIDE_PATH = "/guide";
export const HOME_PATH = "/home";
export const ERROR_PATH = "/error";
export const MODE_PATH = "/mode";
export const ORGANIZATION_PATH = "/organization";
export const INDIVIDUALS_PATH = "/individuals";

export const NEED_USER_INFO_PATH_LIST = [PORTAL_PATH, GUIDE_PATH, HOME_PATH, ORGANIZATION_PATH];
export const NEED_DIALOG_PATH_LIST = [HOME_PATH];
